import React, { useEffect, useState } from "react";
import {
  addPrefixIfSingleLetter,
  formatDate,
  nameValidation,
} from "../../helpers/commonHelper";

import { useTranslation } from "react-i18next";
import { Clear } from "@mui/icons-material";
import { getParametersFromLocalStorage } from "../../helpers/commonHelper";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Select from "react-select";
//export const Name = ({reservationData,isMandatory}) => (
export function NameSection({ reservationData = {} }) {
  const { t } = useTranslation();
  return (
    <div className="reservation-width ">
      <label>{t("Name")}:</label>
      {reservationData.name !== "" &&
      reservationData.name !== null &&
      reservationData.name !== undefined ? (
        <p style={{ margin: 0, whiteSpace: "nowrap" }}>
          {nameValidation(reservationData.name, undefined)}
        </p>
      ) : (
        <span>
          {nameValidation(reservationData.firstName, reservationData.lastName)}
        </span>
      )}
    </div>
  );
}

export function NightsCountSection({ reservationData }) {
  const { t } = useTranslation();

  return (
    <div className="reservation-width-right">
      <label>{t("Number of Nights") + " :"}</label>
      <p>{addPrefixIfSingleLetter(reservationData.nights + "")}</p>
    </div>
  );
}

export function ArrivalDateSection({ isMandatory, reservationData }) {
  const { t } = useTranslation();

  return (
    <div className="reservation-width ">
      <label>{t("Arrival Date") + " :"}</label>
      <p>{formatDate(reservationData?.arrivalDate)}</p>
    </div>
  );
}

export function DepartureDateSection({ isMandatory, reservationData }) {
  const { t } = useTranslation();
  return (
    <div className="reservation-width-right ">
      <label>{t("Departure Date") + " :"}</label>
      <p>{formatDate(reservationData?.departureDate)}</p>
    </div>
  );
}

export function DailyRoomRateSection({
  isMandatory,
  reservationData,
  property,
}) {
  const { t } = useTranslation();

  return (
    <div className="reservation-width">
      <label>{t("Daily Room Rate") + " :"}</label>
      <p>
        {reservationData?.printRate === false ? (
          "-"
        ) : (
          <>
            {property.currency}{" "}
            {parseFloat(reservationData?.roomRate).toFixed(2)}
          </>
        )}
      </p>
    </div>
  );
}
export function TotalChargesSection({ property, totalDue }) {
  const { t } = useTranslation();
  const [showInfoModal, setShowInfoModal] = useState(false);
  const closeModel = () => {
    setShowInfoModal(false);
  };
  const settings = getParametersFromLocalStorage("settings");
  const showPaymentCalculationInfo = settings?.find(
    (setting) =>
      setting.parameterName === "showPaymentCalculationInfo" &&
      setting.parameterValue?.toLowerCase() === "true"
  );
  return (
    <div className="reservation-width-right">
      <div className="highlight">
        <label className="amount-field">{t("Total Charges") + " :"}</label>
        <br />
        <strong>
          <span className="amount-field" style={{ fontWeight: "700" }}>
            {property.currency} {parseFloat(totalDue)?.toFixed(2)}
          </span>
          {showPaymentCalculationInfo && (
            <span
              onClick={() => setShowInfoModal(true)}
              title="More info about incidental charges"
              style={{ cursor: "pointer", marginLeft: "5px", fontSize: "16px" }}
            >
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  border: "2px solid black",
                  backgroundColor: "white",
                }}
              >
                <span
                  style={{
                    color: "black",
                    fontSize: "16px",

                    fontWeight: "bold",
                    fontFamily: "serif", // you can change this
                  }}
                >
                  i
                </span>
              </div>
            </span>
          )}
        </strong>
      </div>
      {showInfoModal && (
        <Modal open={showInfoModal} style={{ zIndex: "1" }}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "32%",
              backgroundColor: "#f5f5f5",
              border: "2px #000",
              boxShadow: "0 0 24px rgba(0, 0, 0, 0.5)",
              padding: "50px",
              borderRadius: "20px",
            }}
          >
            {/* Close Icon */}
            <button
              id="btn-fields-close"
              className="close-icon"
              onClick={closeModel}
            >
              <CloseIcon
                onClick={closeModel}
                style={{ float: "right", margin: "5px", color: "white" }}
              />
            </button>
            <div style={{ textAlign: "center" }}>
              <div>
                <p>{t("PaymentCalculationInfo")}</p>
              </div>
              {/* OK Button */}
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button
                  id="btn-fields-ok"
                  onClick={closeModel}
                  style={{
                    marginTop: "20px",
                    padding: "15px",
                    marginLeft: "15px",
                  }}
                  className="btn button-blue scan-btn"
                >
                  {t("OK")}
                </button>
              </div>
            </div>
          </Box>
        </Modal>
      )}
    </div>
  );
}
export function CheckOutTimeSection({ checkOutTime }) {
  const { t } = useTranslation();

  return (
    // <div className="d-flex justify-content-between communication-detail">
    <div className="row mt-2">
        <div
          className="col-sm-6 col-md-6 col-lg-4"
          style={{ alignContent: "center" }}
        >
      <label>{t("Check-out Time") + " :"}</label>
      </div>
       <div
          className="col-sm-6 col-md-6 col-lg-8"
          style={{ alignContent: "center" }}
        >
      <input
        id="text-fields-checkouttime"
        type="text"
        name="checkoutTime"
        placeholder={t("Check-out Time")}
        autoComplete="off"
        value={checkOutTime}
        disabled
        className="form-control form-control-set"
      />
    </div>
    </div>
  );
}
export function CountryOfResidenceSection({
  isMandatory,
  confirmationDetails = {},
  confirmationDetailsHandler,
  countryValidation,
  countries = [],
  showModalPopup,
  countryCodeAddressUpdate,
}) {
  const { t } = useTranslation();
  const [showView, setShowView] = useState(false);
  const countryOptions =
    countries
      ?.slice()
      .sort((a, b) => a.CountryName.localeCompare(b.CountryName))
      .map((c) => ({
        value: c.CountryCode,
        label: c.CountryName,
      })) || [];

  // Find the selected option based on the country code in confirmationDetails
  const selectedCountry =
    countryOptions.find(
      (option) =>
        String(option.value).toUpperCase() ===
        String(confirmationDetails?.country || "").toUpperCase()
    ) || null;

  useEffect(() => {
    if (
      countryCodeAddressUpdate?.parameterValue &&
      confirmationDetails?.country &&
      confirmationDetails?.country?.includes(
        countryCodeAddressUpdate?.parameterValue
      )
    ) {
      setShowView(true);
    } else setShowView(false);
  }, [confirmationDetails.country]);

  useEffect(() => {
    showModalPopup(false);
  }, []);

  return (
    // <div className="d-flex align-items-center justify-content-between flex-wrap mt-0 mb-2 reservation-detail-content input-container">
    <div>
      <div className="row">
        <div
          className="col-sm-6 col-md-6 col-lg-4"
          style={{ alignContent: "center" }}
        >
          {" "}
          <label className="mb-0 me-2">
            {t("Country of Residence" + " :")}
            {isMandatory && <span style={{ color: "red" }}>*</span>}
          </label>
        </div>
        <div
          className="col-sm-6 col-md-6 col-lg-8"
          style={{ alignContent: "center" }}
        >
          <Select
            name="country"
            value={selectedCountry}
            // onChange={confirmationDetailsHandler}
            className={
              isMandatory && countryValidation
                ? "form-error  form-control-set-select form-control-select "
                : " form-control-set-select form-control-select "
            }
            onChange={(selectedOption) =>
              confirmationDetailsHandler({
                target: { name: "country", value: selectedOption?.value || "" },
              })
            }
            options={countryOptions}
            placeholder={t("Select")}
            isSearchable={true}
            isClearable={true}
            styles={{
              control: (base, state) => ({
                ...base,
                border: "1.5px solid var(--high-light-border)", // fixed border
                boxShadow: "none", // remove focus shadow
                "&:hover": {
                  border: "1.5px solid var(--high-light-border)", // keep border same on hover
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? "var(--high-light-color)" // only selected option
                  : "white",
                color: state.isSelected ? "black" : "inherit",
              }),
            }}
          />
        </div>
      </div>

      {showView && (
        <div
          className="d-flex justify-content-end"
          style={{ marginTop: "10px" }}
        >
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              showModalPopup(true);
            }}
          >
            <i className="bx bx-search"></i> {t("Update Address")}
          </a>
        </div>
      )}
    </div>
  );
}

export function StateSection({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  enterStateValidation,
  stateList = [],
}) {
  const { t } = useTranslation();
  
 // console.log("stateList############",stateList);
  const stateOptions =
    stateList
      ?.slice()
      .sort((a, b) => a.stateName.localeCompare(b.stateName))
      .map((c) => ({
        value: c?.stateCode,
        label: c?.stateName,
      })) || [];

  // Find the selected option based on the country code in confirmationDetails
  const selectedState =
    stateOptions.find(
      (option) =>
        String(option.value).toUpperCase() ===
        String(confirmationDetails?.state || "").toUpperCase()
    ) || null;
  return (
    // <div className="d-flex justify-content-between communication-detail">
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        <label>
          {t("State Of Residence") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <Select
          
          name="state"
          value={selectedState}
          // onChange={confirmationDetailsHandler}
          className={
           isMandatory && enterStateValidation
              ? "form-error  form-control-set-select form-control-select "
              : " form-control-set-select form-control-select "
          }
          onChange={(selectedOption) =>
            confirmationDetailsHandler({
              target: { name: "state", value: selectedOption?.value || "" },
            })
          }
          options={stateOptions}
          placeholder={t("Select")}
          isSearchable={true}
          isClearable={true}
          styles={{
            control: (base, state) => ({
              ...base,
              border: "1.5px solid var(--high-light-border)", // fixed border
              boxShadow: "none", // remove focus shadow
              "&:hover": {
                border: "1.5px solid var(--high-light-border)", // keep border same on hover
              },
            }),
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isSelected
                ? "var(--high-light-color)" // only selected option
                : "white",
              color: state.isSelected ? "black" : "inherit",
            }),
          }}
        />
      </div>

      {/* <select
        name="state"
        value={confirmationDetails.state || ""}
        onChange={confirmationDetailsHandler}
        className={
          isMandatory && enterStateValidation
            ? "form-error form-control form-control-set"
            : "form-control form-control-set"
        }
      >
        <option value="" default>
          {t("Select")}
        </option>
        {stateList
          ?.slice()
          .sort((a, b) => a.stateName.localeCompare(b.stateName))
          .map((state) => (
            <option key={state?.stateCode + state?.stateID} value={state?.stateCode}>
              {state?.stateName}
            </option>
          ))}
      </select> */}

      {/* <input
        id="text-fields-stateofResidence"
        type="text"
        onChange={confirmationDetailsHandler}
        name="state"
        placeholder={t("State Of Residence")}
        autoComplete="off"
        value={confirmationDetails.state}
        required={isMandatory}
        className={
          isMandatory && enterStateValidation
            ? "form-error form-control form-control-set"
            : "form-control form-control-set"
        }
        // className="form-control form-control-set"
      /> */}
    </div>
  );
}

export function NationalitySection({
  isMandatory,
  confirmationDetails = {},
  confirmationDetailsHandler,
  countryValidation,
  countries = [],
}) {
  const nationalitycountryOptions =
    countries
      ?.slice()
      .sort((a, b) => a.CountryName.localeCompare(b.CountryName))
      .map((c) => ({
        value: c.CountryCode,
        label: c.CountryName,
      })) || [];

  // Find the selected option based on the country code in confirmationDetails
  const selectedNationality =
    nationalitycountryOptions.find(
      (option) =>
        String(option.value).toUpperCase() ===
        String(confirmationDetails?.nationality || "").toUpperCase()
    ) || null;
  const { t } = useTranslation();

  const handleNationalityChange = (event) => {
    const selectedCountryCode = event.target.value;
    const selectedCountryName = countries.find(
      (country) => country.CountryCode === selectedCountryCode
    )?.CountryName;

    confirmationDetailsHandler({
      target: {
        name: "nationality",
        value: selectedCountryCode,
      },
    });
  };

  return (
    // <div>
    //   <div className="d-flex justify-content-between communication-detail">
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        <label>
          {t("Nationality") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <Select
          name="nationality"
          value={selectedNationality}
          className={
            isMandatory && countryValidation
              ? "form-error  form-control-set-select form-control-select "
              : " form-control-set-select form-control-select "
          }
          onChange={(selectedOption) =>
            confirmationDetailsHandler({
              target: {
                name: "nationality",
                value: selectedOption?.value || "",
              },
            })
          }
          options={nationalitycountryOptions}
          placeholder={t("Select")}
          isSearchable={true}
          isClearable={true}
          styles={{
            control: (base, state) => ({
              ...base,
              border: "1.5px solid var(--high-light-border)", // fixed border
              boxShadow: "none", // remove focus shadow
              "&:hover": {
                border: "1.5px solid var(--high-light-border)", // keep border same on hover
              },
            }),
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isSelected
                ? "var(--high-light-color)" // only selected option
                : "white",
              color: state.isSelected ? "black" : "inherit",
            }),
          }}
        />
      </div>
    </div>
  );
}

export function EmailSection({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  emailValidation,
  enterEmailValidation,
}) {
  const { t } = useTranslation();
  return (
    // <div className="d-flex justify-content-between communication-detail">
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        <label>
          {t("Email") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-email"
          type="email"
          onChange={confirmationDetailsHandler}
          name="email"
          placeholder={t("Email")}
          autoComplete="off"
          value={confirmationDetails.email}
          required={isMandatory}
          className={
            isMandatory &&
            (emailValidation === true || enterEmailValidation === true)
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function MobileNoSection({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  mobileNoValidation,
}) {
  const { t } = useTranslation();
  // type="number" //set type="text"  if + to be in phone number foreg:+971 to be in phone number field
  return (
    // <div className="communication-detail communication-detail-mobile-number">
    //   <div className="d-flex align-items-center justify-content-between input-container">
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        <label htmlFor="myNumberInput">
          {t("Mobile Number") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        {/* <div className="mobile-number-field-with-message"> */}
        <input
          type="text"
          id="myNumberInput"
          placeholder={t("Mobile Number")}
          onChange={confirmationDetailsHandler}
          autoComplete="off"
          className={
            isMandatory && mobileNoValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
          name="mobileNo"
          value={confirmationDetails.mobileNo}
        />
      </div>
    </div>
    // </div>
  );
}
export function PincodeSection({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  enterPincodeValidation,
}) {
  const { t } = useTranslation();

  return (
    // <div className="d-flex align-items-center justify-content-between communication-detail">
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        <label>
          {t("Pincode") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-pincode"
          type="text"
          onChange={confirmationDetailsHandler}
          name="pincode"
          placeholder={t("Pincode")}
          autoComplete="off"
          value={confirmationDetails.pincode}
          required={isMandatory}
          className={
            isMandatory && enterPincodeValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function UdfSection({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  udfFieldValidation,
}) {
  const { t } = useTranslation();

  return (
    // <div className="d-flex align-items-center justify-content-between communication-detail">
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        <label>
          {t("Udf field") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-udfField"
          type="text"
          onChange={confirmationDetailsHandler}
          name="udfField"
          placeholder={t("Udf field")}
          autoComplete="off"
          value={confirmationDetails.udfField}
          required={isMandatory}
          className={
            isMandatory && udfFieldValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function Udf2Section({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  udfField2Validation,
}) {
  const { t } = useTranslation();

  return (
    // <div className="d-flex align-items-center justify-content-between communication-detail">
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        <label>
          {t("Udf field 2") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-udfField2"
          type="text"
          onChange={confirmationDetailsHandler}
          name="udfField2"
          placeholder={t("Udf field 2")}
          autoComplete="off"
          value={confirmationDetails.udfField2}
          required={isMandatory}
          className={
            isMandatory && udfField2Validation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function Udf3Section({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  udfField3Validation,
}) {
  const { t } = useTranslation();

  return (
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div className="d-flex align-items-center justify-content-between communication-detail"> */}
        <label>
          {t("Udf field 3") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-udfField3"
          type="text"
          onChange={confirmationDetailsHandler}
          name="udfField3"
          placeholder={t("Udf field 3")}
          autoComplete="off"
          value={confirmationDetails.udfField3}
          required={isMandatory}
          className={
            isMandatory && udfField3Validation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function Udf4Section({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  udfField4Validation,
}) {
  const { t } = useTranslation();

  return (
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div className="d-flex align-items-center justify-content-between communication-detail"> */}
        <label>
          {t("Udf field 4") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-udfField4"
          type="text"
          onChange={confirmationDetailsHandler}
          name="udfField4"
          placeholder={t("Udf field 4")}
          autoComplete="off"
          value={confirmationDetails.udfField4}
          required={isMandatory}
          className={
            isMandatory && udfField4Validation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function FirstNameSection({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  firstNameValidation,
}) {
  const { t } = useTranslation();

  return (
    // <div className="d-flex align-items-center justify-content-between communication-detail">
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        <label>
          {t("First Name") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-firstName"
          type="text"
          onChange={confirmationDetailsHandler}
          name="firstName"
          placeholder={t("First Name")}
          autoComplete="off"
          value={confirmationDetails.firstName}
          required={isMandatory}
          className={
            isMandatory && firstNameValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function LastNameSection({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  lastNameValidation,
}) {
  const { t } = useTranslation();

  return (
    // <div className="d-flex align-items-center justify-content-between communication-detail">
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        <label>
          {t("Last Name") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-lastName"
          type="text"
          onChange={confirmationDetailsHandler}
          name="lastName"
          placeholder={t("Last Name")}
          autoComplete="off"
          value={confirmationDetails.lastName}
          required={isMandatory}
          className={
            isMandatory && lastNameValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function DocumentNumberSection({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  documentNumberValidation,
}) {
  const { t } = useTranslation();

  return (
    // <div className="d-flex align-items-center justify-content-between communication-detail">
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        <label>
          {t("Document Number") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-documentNumber"
          type="text"
          onChange={confirmationDetailsHandler}
          name="documentNumber"
          placeholder={t("Document Number")}
          autoComplete="off"
          value={confirmationDetails.documentNumber}
          required={isMandatory}
          className={
            isMandatory && documentNumberValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function DocumentTypeSection({
  isMandatory,
  confirmationDetails = {},
  confirmationDetailsHandler,
  documentTypeValidation,
  documentListTypes = [],
}) {
  const { t } = useTranslation();

  const handleDocumentTypeChange = (event) => {
    const selecteddocumentType = event.target.value;

    confirmationDetailsHandler({
      target: {
        name: "documentType",
        value: selecteddocumentType,
      },
    });
  };

  return (
    // <div>
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div className="d-flex justify-content-between communication-detail"> */}

        <label>
          {t("Document Type") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <select
          name="documentType"
          value={confirmationDetails.documentType || ""}
          onChange={handleDocumentTypeChange}
          className={
            isMandatory && documentTypeValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        >
          <option value="" default>
            {t("Select")}
          </option>
          {documentListTypes?.map((documentType) => (
            <option
              key={documentType?.BODocumentType + documentType?.DocumentID}
              value={documentType?.BODocumentType}
            >
              {documentType?.DocumentName}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
export function AddressLine1Section({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  addressLine1Validation,
}) {
  const { t } = useTranslation();

  return (
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div className="d-flex align-items-center justify-content-between communication-detail"> */}
        <label>
          {t("Address Line 1") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-addressLine1"
          type="text"
          onChange={confirmationDetailsHandler}
          name="addressLine1"
          placeholder={t("Address Line 1")}
          autoComplete="off"
          value={confirmationDetails.addressLine1}
          required={isMandatory}
          className={
            isMandatory && addressLine1Validation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function JobTitleSection({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  enterJobTitleValidation,
}) {
  const { t } = useTranslation();

  return (
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div className="d-flex align-items-center justify-content-between communication-detail"> */}
        <label>
          {t("Job Title") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-jobTitle"
          type="text"
          onChange={confirmationDetailsHandler}
          name="jobTitle"
          placeholder={t("Job Title")}
          autoComplete="off"
          value={confirmationDetails.jobTitle}
          required={isMandatory}
          className={
            isMandatory && enterJobTitleValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function CitySection({
  isMandatory,
  confirmationDetailsHandler,
  confirmationDetails = {},
  //cityValidation,
  enterCityValidation,
}) {
  const { t } = useTranslation();

  return (
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div className="d-flex justify-content-between communication-detail"> */}
        <label>
          {t("City Of Residence") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-cityofResidence"
          type="text"
          onChange={confirmationDetailsHandler}
          name="city"
          placeholder={t("City Of Residence")}
          autoComplete="off"
          value={confirmationDetails.city}
          required={isMandatory}
          className={
            isMandatory && enterCityValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
          // className="form-control form-control-set"
        />
      </div>
    </div>
  );
}

export function PopupPincodeSection({
  isMandatory,
  addressChangeHandler,
  addressData,
  pincodeValidation,
  searchPinCode,
  isDisable,
  clearData,
  confirmationDetails,
  isClear,
}) {
  const { t } = useTranslation();

  return (
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div>
      <div className="d-flex justify-content-between communication-detail"> */}
        <label>
          {t("Pincode") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-pincodepopup"
          type="text"
          onChange={addressChangeHandler}
          name="pincode"
          placeholder={t("Pincode")}
          autoComplete="off"
          value={addressData?.pincode}
          required={isMandatory}
          disabled={isDisable}
          className={
            isMandatory && pincodeValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
          style={{ textAlign: "right", width: "200px" }}
        />
      </div>

      <div
        className="d-flex justify-content-end"
        style={{ alignItems: "flex-end" }}
      >
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            isClear ? clearData() : searchPinCode();
          }}
        >
          <i className={`bx ${isClear ? "" : "bx-search"}`}></i>
          {t(isClear ? "Clear" : "Search")}
        </a>
      </div>
    </div>
  );
}
export function PopupStateSection({
  isMandatory,
  addressChangeHandler,
  addressData = {},
  pincodeValidation,
  confirmationDetails,
  isDisable,
}) {
  const { t } = useTranslation();

  return (
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div className="d-flex justify-content-between communication-detail"> */}
        <label>
          {t("State") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-state"
          type="text"
          onChange={addressChangeHandler}
          name="state"
          placeholder={t("State")}
          autoComplete="off"
          value={addressData?.state}
          required={isMandatory}
          disabled={isDisable}
          className={
            isMandatory && pincodeValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
          // readOnly
          // disabled
        />
      </div>
    </div>
  );
}
export function PopupNeighborhoodSection({
  isMandatory,
  addressChangeHandler,
  addressData = {},
  pincodeValidation,
  confirmationDetails,
}) {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div className="d-flex justify-content-between communication-detail"> */}
        <label>
          {t("Neighborhood") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-neighbourhood"
          type="text"
          onChange={addressChangeHandler}
          name="neighborhood"
          placeholder={t("Neighborhood")}
          autoComplete="off"
          value={addressData?.neighborhood}
          required={isMandatory}
          className={
            isMandatory && pincodeValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function PopupComplementSection({
  isMandatory,
  addressChangeHandler,
  addressData = {},
  pincodeValidation,
  isDisable,
  confirmationDetails,
}) {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div className="d-flex justify-content-between communication-detail"> */}
        <label>
          {t("Complement") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-complement"
          type="text"
          onChange={addressChangeHandler}
          name="complement"
          placeholder={t("Complement")}
          autoComplete="off"
          value={addressData?.complement}
          required={isMandatory}
          disabled={isDisable}
          className={
            isMandatory && pincodeValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function PopupCitySection({
  isMandatory,
  addressChangeHandler,
  addressData = {},
  pincodeValidation,
  confirmationDetails,
  isDisable,
}) {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div className="d-flex justify-content-between communication-detail"> */}
        <label>
          {t("City")}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-city"
          type="text"
          onChange={addressChangeHandler}
          name="city"
          placeholder={t("City")}
          autoComplete="off"
          value={addressData?.city}
          required={isMandatory}
          disabled={isDisable}
          className={
            isMandatory && pincodeValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
          // readOnly
          // disabled
        />
      </div>
    </div>
  );
}
export function PopupStreetSection({
  isMandatory,
  addressChangeHandler,
  addressData = {},
  pincodeValidation,
  isDisable,
  confirmationDetails,
  isClear,
  searchPinCode,
}) {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div className="d-flex justify-content-between communication-detail"> */}
        <label>
          {t("Street") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-street"
          type="text"
          onChange={addressChangeHandler}
          onClick={(e) => {
            e.preventDefault();
            if (!isClear) {
              searchPinCode();
            }
          }}
          name="street"
          placeholder={t("Street")}
          autoComplete="off"
          value={addressData?.street}
          required={isMandatory}
          disabled={isDisable}
          className={
            isMandatory && pincodeValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function PopupNumberofResidenceSection({
  isMandatory,
  addressChangeHandler,
  pincodeValidation,
  confirmationDetails,
  addressData,
}) {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div
        className="col-sm-6 col-md-6 col-lg-4"
        style={{ alignContent: "center" }}
      >
        {/* <div className="d-flex justify-content-between communication-detail"> */}
        <label>
          {t("NumberofResidence") + " :"}
          {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <div
        className="col-sm-6 col-md-6 col-lg-8"
        style={{ alignContent: "center" }}
      >
        <input
          id="text-fields-NumberofResidence"
          type="text"
          onChange={addressChangeHandler}
          name="numberofResidence"
          placeholder={t("NumberofResidence")}
          autoComplete="off"
          value={addressData?.numberofResidence}
          required={isMandatory}
          className={
            isMandatory && pincodeValidation
              ? "form-error form-control form-control-set"
              : "form-control form-control-set"
          }
        />
      </div>
    </div>
  );
}
export function GenderSection({
  isMandatory,
  confirmationDetails = {},
  confirmationDetailsHandler,
  genderValidation,
  genderOptions = [],
}) {
  const { t } = useTranslation();

  const handleGenderChange = (event) => {
    const selectedGender = event.target.value;

    confirmationDetailsHandler({
      target: {
        name: "gender",
        value: selectedGender,
      },
    });
  };

  return (
    <div>
      <div className="row">
        <div
          className="col-sm-6 col-md-6 col-lg-4"
          style={{ alignContent: "center" }}
        >
          {/* <div className="d-flex justify-content-between communication-detail"> */}
          <label>
            {t("Gender") + " :"}
            {isMandatory && <span style={{ color: "red" }}>*</span>}
          </label>
        </div>
        <div
          className="col-sm-6 col-md-6 col-lg-8"
          style={{ alignContent: "center" }}
        >
          <select
            name="gender"
            value={confirmationDetails.gender || ""}
            onChange={handleGenderChange}
            className={
              isMandatory && genderValidation
                ? "form-error form-control form-control-set"
                : "form-control form-control-set"
            }
          >
            <option value="" default>
              {t("Select")}
            </option>
            {genderOptions?.map((genderOption) => (
              <option key={genderOption.value} value={genderOption.value}>
                {genderOption.displayText}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
